module.exports = __webpack_public_path__ + "static/media/image5.4516c461.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/carAuthorization/img/image5.png
// module id = 329
// module chunks = 0